import { render, staticRenderFns } from "./ContractConfigGlobal.vue?vue&type=template&id=b0283e96&"
import script from "./ContractConfigGlobal.vue?vue&type=script&lang=js&"
export * from "./ContractConfigGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports